<template>
  <div>
    <TopAppBar :leftBtnMode="leftBtnMode" :rightBtnMode="rightBtnMode" :title="title" :leftBtnMethod="goBacKPreviousPage"
      :rightBtnMethod="rightBtnMethod" staticMode="true"></TopAppBar>

    <div id="tab1" class="t-color-content1 pdt-16 pdb-18" v-if="basicData">
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="t-headline7 t-color-title l-spacing6 pdt-10 pdb-8 font-m" v-html="basicData && basicData.contents ? basicData.contents.subject : ''
          "></div>
        <div class="t-body3 t-color-content1 l-spacing42 font-r" v-html="basicData.contents.body"></div>
      </div>
      <div class="pdt-16" v-for="(imagepre, i) in basicData && basicData.contents
        ? basicData.contents.images
        : ''" :key="i">
        <img :src="imagepre.resourceUri" alt="" class="attachedImage" />
      </div>
    </div>
  </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import eventApi from "@/api/eventApi.js";

export default {
  data() {
    return {
      eventId: "",
      basicData: "",
      board: "",
    };
  },
  components: {
    TopAppBar,
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.board = this.$route.query.board;
    this.setTopAppBarBack(this.$t("S10029"));
    this.eventId = this.$router.currentRoute.params.id;
    this.fetchData(this.eventId, this.board);
  },
  methods: {
    fetchData(eventId, board) {
      let responseData = null;
      this.$showLoading();
      // get learn basic information
      eventApi
        .getEventDetails({ eventId, board })
        .then((response) => {
          this.basicData = response.data.data;
          // set learning status
          this.$hideLoading();
        })
        .catch((err) => {
          responseData = err.response.data.meta;
          this.$error({ content: responseData.errMsg }).then(() => { });
        });
    },
    goBacKPreviousPage() {
      this.$router.push("/event?board=" + this.board);
    },
  },
};
</script>
<style scoped>
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.b-radius2 {
  border-radius: 2px;
}

.l-spacing36 {
  letter-spacing: -0.36px;
}

.font-16 {
  font-size: 16px;
}

.bg-blue3 {
  background-color: #80aed4;
}
</style>